import React, {Fragment} from 'react'
import {OrderedMap, Set} from 'immutable'
import _ from 'lodash'
import {pipe} from 'lib/functional'
import queryString from 'query-string'

// These constants are used to set and determine the different states of the smart export button
export const SMART_EXPORT_DEFAULT = 'default'
export const SMART_EXPORT_PHONE_PUSH = 'phone_push'
export const SMART_EXPORT_FILE_DOWNLOAD = 'file_download'

export const formatsForObjectType = (objectType) => OrderedMap(
  Object.assign(
    {
      fit: {
        name: 'FIT Course',
        ext: 'fit',
        defaultExpanded: 'route',
        description: <Fragment>FIT is the best format for turn-by-turn directions on modern <strong>Garmin Edge Devices</strong>.</Fragment>,
        supportedOptions: Set(['turnNotificationDistance']),
        smartExportable: true
      },
      tcx: {
        name: 'TCX Course',
        ext: 'tcx',
        description: <Fragment>Compatible with most <strong>modern GPS units</strong>. Provides turn by turn directions including custom cue entries, but may consume more space than FIT.</Fragment>,
        supportedOptions: objectType === 'route' ? Set(['turnNotificationDistance', 'reduceTo']) : Set(['reduceTo']),
        smartExportable: true
      },
      tcxh: {
        name: 'TCX History',
        ext: 'tcx',
        defaultExpanded: 'trip',
        subFormat: 'history',
        description: <Fragment>Useful for uploading your activity to another service, keeping records on your own computer etc.</Fragment>,
        supportedOptions: Set(),
        smartExportable: false
      },
      gpxt: {
        name: 'GPX Track',
        ext: 'gpx',
        subFormat: 'track',
        description: <Fragment>Useful for any GPS unit. <strong>Contains no cuesheet entries</strong>, only track information (breadcrumb trail).</Fragment>,
        supportedOptions: Set(['poiAsWpt', 'cuesAsWpt', 'reduceTo']),
        smartExportable: true
      },
      kml: {
        name: 'Google Earth',
        ext: 'kml',
        description: <Fragment>Allows you to view this route in Google Earth.</Fragment>,
        supportedOptions: Set()
      }
    }, objectType === 'route' && {
      gpxr: {
        name: 'GPX Route',
        ext: 'gpx',
        subFormat: 'route',
        description: <Fragment>Only the cuesheet entries, not the entire track. Not useful for most, you most likely want a GPX Track.</Fragment>,
        supportedOptions: Set()
      },
      csv: {
        name: 'Cuesheet CSV',
        ext: 'csv',
        description: <Fragment>Only the cue sheet. You can print it from Excel or another spreadsheet program.</Fragment>,
        supportedOptions: Set()
      }
    }
  )
)

export const fileDownloadURL = (format, id, objectType, activeOptions = Set(), privacyCode, turnNotificationDistance) => {
  const {supportedOptions} = format

  const filteredOptions = activeOptions
    .filter((k) => supportedOptions.has(k))
    .toMap()
    .map(() => true)

  const mergeIf = (condition, toMerge) => (options) => (
    condition ? options.merge(toMerge) : options
  )

  const queryOptions = pipe(
    mergeIf(filteredOptions.has('turnNotificationDistance'), {turnNotificationDistance}),
    mergeIf(filteredOptions.has('reduceTo'), {reduceTo: 500}),
    mergeIf(format.subFormat, {subFormat: format.subFormat}),
    mergeIf(privacyCode, {privacyCode: privacyCode})
  )(filteredOptions)

  const query = queryString.stringify(
    queryOptions.mapKeys(k => _.snakeCase(k)).toJS()
  )

  const urlBase = format.pathOverride
    ? `/${objectType}s/${id}${format.pathOverride}`
    : `/${objectType}s/${id}.${format.ext}`

  return query
    ? `${urlBase}?${query}`
    : urlBase
}
